import { render, staticRenderFns } from "./LocationSettings.vue?vue&type=template&id=3127f4b2&scoped=true&"
import script from "./LocationSettings.vue?vue&type=script&lang=ts&"
export * from "./LocationSettings.vue?vue&type=script&lang=ts&"
import style0 from "./LocationSettings.vue?vue&type=style&index=0&id=3127f4b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127f4b2",
  null
  
)

export default component.exports